import { render, staticRenderFns } from "./Pagination04.vue?vue&type=template&id=23521e63"
import script from "./Pagination04.vue?vue&type=script&lang=js"
export * from "./Pagination04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports